import { gql } from 'apollo-angular';

export const UPDATE_PARTNER_DOCUMENT = gql`
    mutation updatePartnerDocument($updatePartnerDocumentInput:UpdatePartnerDocumentInput!) {
        updatePartnerDocument(updatePartnerDocumentInput:$updatePartnerDocumentInput) {
            partnerDocumentId
            partnerId
            type
            subType
            link
            idNumber
            firstName
            middleName
            lastName
            address
            expirationDate
            gender
            birthdate
            status
            dateApprove
            dateUpdated
            dateCreated
            notes
        }
    }
`;

export const TOPUP_MANUAL = gql`
    mutation topUpManual($partnerId: PartnerHashedId!, $amount:Float!) {
        topUpManual(partnerId:$partnerId, amount:$amount) {
            message
        }
    }
`;

export const APPROVE_PARTNER_ACCOUNT = gql`
    mutation approvePartnerAccount($partnerId: PartnerHashedId!) {
        approvePartnerAccount(partnerId: $partnerId) {
            message
        }
    }
`;

export const VERIFY_PARTNER = gql`
    mutation verifyPartner($partnerId: PartnerHashedId!) {
        verifyPartner(partnerId:$partnerId) {
            message
        }
    }
`;

export const CREATE_PARTNER_DOCUMENT = gql`
    mutation createPartnerDocument($createPartnerDocumentInput:CreatePartnerDocumentInput!) {
        createPartnerDocument(createPartnerDocumentInput:$createPartnerDocumentInput) {
            partnerDocumentId
            idNumber
            firstName
            middleName
            lastName
            isDone
            link
            status
            type
            subType
            address
            dateCreated
            expirationDate
            birthdate
            dateApprove
            gender
        }
    }
`;

/** `partnerId` scopes the delete to the partner whose page it came from. */
export const DELETE_PARTNER_DOCUMENT = gql`
    mutation deletePartnerDocument($partnerDocumentId:HashedId!, $partnerId:PartnerHashedId) {
        deletePartnerDocument(partnerDocumentId:$partnerDocumentId, partnerId:$partnerId) {
            message
        }
    }
`;

export const SEND_FOLLOW_UP_NOTIFICATION = gql`
    mutation sendFollowUpNotification($partnerId:PartnerHashedId!) {
        sendFollowUpNotification(partnerId:$partnerId) {
            message
        }
    }
`;

export const UPDATE_PARTNER_DOCUMENT_BY_ID = gql`
    mutation updatePartnerDocumentById($updatePartnerDocumentByIdInput:UpdatePartnerDocumentByIdInput!) {
        updatePartnerDocumentById(updatePartnerDocumentByIdInput:$updatePartnerDocumentByIdInput) {
            partnerDocumentId
            partnerId
            type
            subType
            link
            idNumber
            firstName
            middleName
            lastName
            address
            expirationDate
            gender
            birthdate
            status
            dateApprove
            dateUpdated
            dateCreated
            notes
        }
    }
`;

export const UPDATE_PARTNER_ACCOUNT_STATUS = gql`
    mutation updatePartnerAccountStatus($partnerId: PartnerHashedId!, $status: PartnerStatusInput!) {
        updatePartnerAccountStatus(partnerId: $partnerId, status: $status) {
            partnerId
            status
        }
    }
`;
